import { UseQueryResult, keepPreviousData } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'

import { parseTrainer, Trainer } from '../../models/Trainer'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsGroups, ReturnsUsers } from '../useInvalidate'

export default function useTrainerSuggestions(providerUuid?: string | null, init?: string | null) {
  const [query, setQuery] = useState(init)

  const [currentQuery, debounceState] = useDebounce(query, 300)

  const result: UseQueryResult<Trainer[]> = useApiQuery({
    queryKey: ['trainerSuggestions', ReturnsUsers, ReturnsGroups, providerUuid, currentQuery],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const searchParams = new URLSearchParams()
      searchParams.append('page', '1')
      if (currentQuery) {
        searchParams.append('search', currentQuery)
      }
      if (providerUuid) {
        searchParams.append('provider_uuid', providerUuid)
      }

      return parseTrainer
        .array((await api.get('user/trainer-propositions?' + searchParams.toString()))?.data)
        .filter(({ error }) => !error)
    },
  })

  const suggestions = useMemo(() => result.data || [], [result.data])

  return {
    query,
    setQuery,
    suggestions,
    isFetching: result.isFetching || debounceState.isPending(),
    result,
  }
}
